import { DownloadIcon, TrashBinIcon } from '../../../assets/icons/icons';
import { Button } from '../../ui/Button/Button';
import { plural } from '../../../utils/format';
import styles from './BulkBar.module.scss';
import React from 'react';

interface BulkBarProps {
    count: number;
    onExport: () => void;
    onDelete: () => void;
    onClear: () => void;
}

export function BulkBar({ count, onExport, onDelete, onClear }: BulkBarProps) {
    if (count === 0) return null;

    return (
        <div className={styles.bulkbar}>
            <b>
                {count} {plural(count, 'проект выбран', 'проекта выбрано', 'проектов выбрано')}
            </b>

            <Button compact icon={<DownloadIcon />} onClick={onExport}>
                Выгрузить
            </Button>
            <Button compact icon={<TrashBinIcon />} onClick={onDelete}>
                Удалить
            </Button>

            <button type="button" className={styles.close} onClick={onClear}>
                Снять выделение
            </button>
        </div>
    );
}
